/* eslint-disable no-unused-vars, quotes, no-lonely-if, prefer-destructuring, react/no-unused-prop-types */
/* eslint-disable array-callback-return, brace-style, object-curly-newline, no-unneeded-ternary */
/* eslint-disable max-len, class-methods-use-this, react/prop-types, jsx-a11y/no-static-element-interactions */
/* eslint-disable no-mixed-operators, react/jsx-closing-bracket-location, no-loop-func */
/* eslint-disable react/no-unused-state, no-prototype-builtins, no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-for, no-restricted-syntax, jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable quote-props, jsx-a11y/anchor-is-valid, operator-assignment */
/* eslint-disable camelcase, arrow-parens, no-plusplus, prefer-template, jsx-a11y/alt-text */
/* eslint-disable object-shorthand, react/jsx-curly-brace-presence, arrow-body-style */
/* eslint-disable react/no-did-mount-set-state, function-paren-newline, jsx-a11y/click-events-have-key-events */
import React, { PureComponent } from 'react';
import {
  UncontrolledTooltip, Container, Row, Col, Button, Table,
  ButtonToolbar, Card, CardBody, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import ls from 'local-storage';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import renderTextInput from '../../../../../shared/components/form/TextInput';

class KpiPlanApprovalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    wfo_id: PropTypes.func.isRequired,
    emp_id: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      token: '',
      apiws: '',
      idUser: '',
      empid: '',
      empname: '',
      empcode: '',
      redirectUrl: false,
      phaseName: '',
      periodPhaseId: '',
      periodId: '',
      phaseId: '',
      kpiPlanData: [],
      kpiPlanCategory: [],
      kpiPlanStrategic: [],
      totalWeight: 0,
      wflId: '',
      kpiState: false,
    };
    this.getKpiplan = this.getKpiplan.bind(this);
  }

  componentDidMount = () => {
    this.props.destroy();
    this.setState({ token: ls.get('token') });
    this.setState({ apiws: ls.get('ws_ip') });
    this.setState({ idUser: ls.get('user_cred').usr_id });
    this.getCase();
  }

  getCase() {
    const wfo = this.props.wfo_id;
    const emp = this.props.emp_id;
    const config = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    axios.get(
      `${ls.get('ws_ip')}/pfmkpiplan/getAllitemkpiplancase/${wfo}/${emp}`,
      config,
    ).then((res) => {
      if (res.data.status === 'ok') {
        const dataResponse = res.data.data[0];
        this.setState({
          periodId: dataResponse.pfp_id,
          phaseId: dataResponse.pph_id,
          periodPhaseId: dataResponse.ppp_id,
        });
        this.setState({ kpiState: true });
        setTimeout(() => {
          if (this.state.kpiState) {
            this.getKpiplan();
            this.getFlow();
            this.setState({ kpiState: false });
          }
        }, 500);
      }
    });
  }

  getKpiplan() {
    const { periodId, phaseId, periodPhaseId } = this.state;
    const emp = this.props.emp_id;
    const wfo = this.props.wfo_id;
    const config = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    axios.get(
      `${ls.get('ws_ip')}/pfmkpiplan/getallitemcategorycase/${emp}/${periodId}/${phaseId}/${periodPhaseId}/${wfo}`,
      config,
    ).then((res) => {
      if (res.data.status === 'ok') {
        if (res.data.data.category.length > 0) {
          console.log(res.data.data);
          const category = res.data.data.category;
          const strategic = res.data.data.strategic;
          const kpi = res.data.data.kpi;
          console.log('category', category);
          console.log('strategic', strategic);
          console.log('kpi', kpi);
          this.setState({
            kpiPlanCategory: category,
            kpiPlanStrategic: strategic,
            kpiPlanData: kpi,
          });
        }
      }
    });
  }

  getFlow() {
    const { periodId, phaseId, periodPhaseId } = this.state;
    const { token, apiws } = this.state;
    console.log('getFlow.phaseId', phaseId);
    const config = {
      headers: {
        Authorization: `bearer ${token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    axios.post(
      `${apiws}/workflow/getWorkflowPerformance/${phaseId}`,
      '',
      config,
    ).then((response) => {
      if (response.data.status === 'ok') {
        const dataResponse = response.data.data.performance[0];
        this.setState({
          wflId: dataResponse.wfl_id,
          workflow: dataResponse.workflow,
          activity: dataResponse.activity,
        });
      }
    });
  }

  render() {
    const { t } = this.props;
    const {
      redirectUrl,
      kpiPlanData,
      kpiPlanCategory,
      kpiPlanStrategic,
    } = this.state;

    if (redirectUrl) {
      const link = (<Redirect to={{ pathname: '/workflow/approval' }} />);
      return link;
    }

    const arrDataKpiPlan = [];
    for (let i = 0; i < kpiPlanCategory.length; i++) {
      console.log('kpiPlanCategory.length', kpiPlanCategory.length);
      const category = kpiPlanCategory[i];
      arrDataKpiPlan.push(
        <div className="form__form-group">
          <span className="form__form-group-label" style={{ paddingLeft: '15px' }}>{t('LBL.CATEGORY')}</span>
          <div className="form__form-group-field">
            <Col xs={5} md={5} lg={5} xl={5}>
              <input
                style={{ fontWeight: 'bold' }}
                name="category"
                disabled="true"
                value={category.category_name}
              />
            </Col>
          </div>
        </div>,
      );
      for (let j = 0; j < kpiPlanStrategic[`${category.pcr_id}`].length; j++) {
        const strategic = kpiPlanStrategic[`${category.pcr_id}`][j];
        arrDataKpiPlan.push(
          <div className="form__form-group">
            <span className="form__form-group-label" style={{ paddingLeft: '15px' }}>{t('LBL.STRATEGIC_OBJECTIVE')}</span>
            <div className="form__form-group-field">
              <Col xs={5} md={5} lg={5} xl={5}>
                <input
                  name="startegic"
                  disabled="true"
                  value={strategic.strategic_objective_name}
                />
              </Col>
            </div>
          </div>,
        );
        for (let k = 0; k < kpiPlanData[`${category.pcr_id}`][`${strategic.pso_id}`].length; k++) {
          const kpi = kpiPlanData[`${category.pcr_id}`][`${strategic.pso_id}`][k];
          const satuan = (kpi.target === '%') ? '%' : '';
          arrDataKpiPlan.push(
            <div className="form__form-group">
              <span className="form__form-group-label" style={{ paddingLeft: '15px' }}>{t('LBL.KPI')}</span>
              <div className="form__form-group-field">
                <Col xs={3} md={3} lg={3} xl={3}>
                  <textarea
                    name="kpi"
                    disabled="true"
                    value={kpi.kpi_name}
                  />
                </Col>
                <Col xs={1} md={1} lg={1} xl={1}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">{t('LBL.TARGET')}</span>
                    <div className="form__form-group-field number-form" style={{ width: '100%', padding: '0px' }}>
                      <input name="target" value={`${kpi.target_value} ${satuan}`} disabled />
                    </div>
                  </div>
                </Col>
                <Col xs={2} md={2} lg={2} xl={2}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">{t('LBL.WEIGHT')}</span>
                    <div className="form__form-group-field number-form" style={{ width: '100%', padding: '0px' }}>
                      <Field
                        name={`weight_${kpi.ppn_id}_${category.pcr_id}`}
                        component={renderTextInput}
                        type="text"
                        placeholder={kpi.plan_weight}
                        disabled
                        maxLength="3"
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={2} md={2} lg={2} xl={2}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">{t('LBL.DIDNT_REACH')}</span>
                    <div className="form__form-group-field" style={{ width: '100%', padding: '0px' }}>
                      <Field
                        component={renderTextInput}
                        name={`pto_1_${kpi.ppn_id}`}
                        type="text"
                        placeholder={kpi.didnt_reach}
                        disabled
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={2} md={2} lg={2} xl={2}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">{t('LBL.REACH')}</span>
                    <div className="form__form-group-field" style={{ width: '100%', padding: '0px' }}>
                      <Field
                        component={renderTextInput}
                        name={`pto_2_${kpi.ppn_id}`}
                        type="text"
                        placeholder={kpi.reach}
                        disabled
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={2} md={2} lg={2} xl={2}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">{t('LBL.EXCEED')}</span>
                    <div className="form__form-group-field" style={{ width: '100%', padding: '0px' }}>
                      <Field
                        component={renderTextInput}
                        name={`pto_3_${kpi.ppn_id}`}
                        type="text"
                        placeholder={kpi.exceed}
                        disabled
                      />
                    </div>
                  </div>
                </Col>
              </div>
            </div>
            ,
          );
        }
      }
      arrDataKpiPlan.push(
        <div className="form__form-group">
          <span className="form__form-group-label" style={{ paddingLeft: '15px' }}>{t('LBL.WEIGHT')} {category.category_name}</span>
          <div className="form__form-group-field number-form">
            <Col xs={3} md={3} lg={3} xl={3}>
              <Field
                component={renderTextInput}
                type="text"
                disabled
                placeholder={category.weight_value}
              />
            </Col>
          </div>
        </div>,
      );
      arrDataKpiPlan.push(
        <div className="form__form-group">
          <span className="form__form-group-label" style={{ paddingLeft: '15px' }}>{t('LBL.RESULT')} {category.category_name}</span>
          <div className="form__form-group-field number-form">
            <Col xs={3} md={3} lg={3} xl={3}>
              <Field
                name={`weightverify_${category.pcr_id}`}
                component={renderTextInput}
                type="text"
                disabled
                placeholder={category.plan_weight}
              />
            </Col>
          </div>
        </div>,
      );
      arrDataKpiPlan.push(
        <hr style={{ width: '100%' }} />,
      );
    }
    return (
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12}>
            <Card>
              <CardBody style={{ 'padding': '20px 20px 30px 20px' }}>
                <Row style={{ padding: '0px' }}>
                  <Col xs={12} md={12} lg={12} xl={12}>
                    <div>
                      <form className="form form--horizontal">
                        {arrDataKpiPlan}
                      </form>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default reduxForm({
  form: 'kpiplanapproval',
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(translate('global')(KpiPlanApprovalForm));
